<template>
  <v-form ref="formDocument">
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="document.titulo"
          label="Título"
          placeholder="Título"
          outlined
          :rules="[rules.required]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="document.classificacao"
          label="Classificação"
          placeholder="Classificação"
          outlined
          :rules="[rules.required]"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-select
          label="Tipo"
          v-model="document.tipo"
          return-object
          placeholder="Selecione o tipo"
          outlined
          :items="tiposArtigo"
          item-text="descricao"
          item-value="descricao"
          :rules="[rules.required]"
          no-data-text="Nenhum registro encontrado"
        ></v-select>
      </v-col>
      <v-col cols="12" md="2">
        <v-select
          label="Status"
          v-model="document.status"
          placeholder="Selecione o status"
          outlined
          :items="items"
          :rules="[rules.required]"
          no-data-text="Nenhum registro encontrado"
        ></v-select>
      </v-col>
      <v-col cols="12" md="2">
        <v-autocomplete
          ref="tagRef"
          v-model="newTag"
          label="Tag"
          return-object
          placeholder="Selecione a tag"
          outlined
          :items="tags"
          item-text="descricao"
          item-value="_id"
          @change="changeTag"
          no-data-text="Nenhum registro encontrado"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="document.conteudo"
          label="Conteúdo"
          placeholder="Conteúdo"
          rows="10"
          row-height="25"
          auto-grow
          outlined
          :rules="[rules.required]"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <div class="mt-5">
          <v-btn
            text
            class="mr-5"
            @click="$emit('cancel')"
          >Cancelar</v-btn>
          <v-btn
            color="primary"
            @click="submitForm"
            :loading=loading
          >Salvar</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Article from '../../domain/article/Article';

export default {
  name: 'DocumentForm',
  props: {
    document: {
      type: Object,
      default: () => new Article(),
    }
  },
  data: () => ({
    valid: true,
    newTag: '',
    items: ['Em Progresso', 'Solicitar Revisão', 'Solicitar Correção', 'Publicado'],
    rules: {
      required: value => !!value || 'Campo obrigatório.',
    },
  }),
  computed: {
    ...mapGetters(['tiposArtigo', 'tags', 'loading'])
  },
  methods: {
    ...mapActions(['fetchTiposArtigo', 'fetchTags']),
    changeTag() {
      const addTag = { ...this.newTag };

      const tagExists = this.document.tags.find(tag => tag.descricao === addTag.descricao);

      if (!tagExists) {
        this.document.tags.push(addTag);
      } else {
        this.$store.commit('showSnackbar', { text: `Tag (${addTag.descricao}) já existe no artigo` });
      }

      this.$refs.tagRef.reset();
    },
    submitForm() {
      if (this.$refs.formDocument.validate()) {
        this.$emit('save', this.document);
      } else {
        this.$store.commit('showSnackbar', { text: 'Por favor preencha os campos obrigatórios.' });
      }
    },
    initializeForm() {
      if (!this.tiposArtigo.length) this.fetchTiposArtigo({});
      if (!this.tags.length) this.fetchTags();
    }
  },
  created() {
    this.initializeForm({});
  }
}
</script>

<style>

</style>